import { useCallback, useContext } from 'react';
import { TranscriptSpeakersContext } from '@/containers/Transcript/context';
import { CallRole_Utils } from '@/enums';

export const useGetSpeakerLabel = () => {
  const map = useContext(TranscriptSpeakersContext);

  const getSpeakerLabel = (speakerIndex: number) => {

    const speaker = map?.[speakerIndex];
    const fallback = `Speaker ${speakerIndex + 1}`;

    const name = speaker?.name
      ? speaker.name
      : typeof speaker?.role === 'number'
        ? CallRole_Utils.getName(speaker.role)
        : fallback;

    return name || fallback;
  };

  return useCallback(getSpeakerLabel, [map]);
};